import { RoleService } from './../../../../management/shared/services/roleService';
// Angular
import { Component, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';

@Component({
	selector: 'kt-user-profile2',
  templateUrl: './user-profile2.component.html',
  styleUrls: ['./user-profile2.component.scss'],
})
export class UserProfile2Component implements OnInit {
	// Public properties
	user$: Observable<User>;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private store: Store<AppState>
		,private roleService: RoleService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.user$ = this.store.pipe(select(currentUser));

	}

	/**
	 * Log out
	 */
	logout() {
		this.store.dispatch(new Logout());
	}
	admin() {
		if (this.roleService.haveRole('Edit_SheedLab'))
			return '/admin/dashboard';
		else if (this.roleService.haveRole('Read_Orders'))
			return '/admin/purchases';
		else if (this.roleService.haveRole('Support_Ticket'))
			return '/admin/tickets';
		else if (this.roleService.haveRole('Read_Reseller'))
			return '/admin/reseller';
	}
}
